import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import PasswordChecklist from "react-password-checklist";

import { showErrorDialog, showSuccessDialog } from "../../../utility";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
import { resetPassword } from "../../../pages/administrator/master-user/userSlice";
import Swal from "sweetalert2";

export const ResetPassword = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  const dataParams = params.location.state.params;

  console.log(params, "params");
  console.log(dataParams, "dataParams");

  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const handleSave = async () => {
    const id = dataParams.userId;
    const params = { newPassword: passwordAgain };

    // cek password
    if (password === passwordAgain) {
    } else {
      showErrorDialog("Password don't match");
      return;
    }
    try {
      const response = await dispatch(resetPassword({ id, params }));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed) await history.goBack();
      } else {
        Swal.fire({
          title: "Error!",
          text: `${response.payload.data.message}`,
          icon: "error",
          heightAuto: false,
          confirmButtonText: "Ok",
        });
        return;
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return (
    <>
      <div className="login-form login-forgot" style={{ display: "block" }}>
        <div className="text-center mb-10 mb-lg-20">
          <h3 className="font-size-h1 text-white">Reset Password </h3>
        </div>

        <Form>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>
              <b className="text-white">Username</b>
            </Form.Label>
            <Col sm={8}>
              <Form.Control disabled type="text" value={dataParams.username} />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>
              <b className="text-white">New Password</b>
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                required
                type={passwordShown ? "text" : "password"}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
            </Col>
            <span className="mt-3">
              <RemoveRedEye onClick={togglePasswordVisiblity} />
            </span>
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>
              <b className="text-white">Re-Type Password</b>
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                required
                type={passwordShown ? "text" : "password"}
                onChange={(e) => setPasswordAgain(e.target.value)}
                value={passwordAgain}
              />
            </Col>
          </Form.Group>
          {/* <Form.Group
            as={Row}
            className={`mb-3 ${
              password.length || passwordAgain.length > 0 ? "" : "hide"
            }`}
          >
            <Form.Label column sm={2}></Form.Label>
            <Col sm={6}>
              <PasswordChecklist
                rules={[
                  "minLength",
                  "specialChar",
                  "number",
                  "capital",
                  "match",
                ]}
                minLength={8}
                value={password}
                valueAgain={passwordAgain}
                onChange={(isValid) => {}}
                style
              />
            </Col>
          </Form.Group> */}
        </Form>
        <div className="form-group d-flex flex-wrap flex-center">
          <Link to="/auth">
            <Button
              type="button"
              id="kt_login_forgot_cancel"
              className="btn btn-outline-primary font-weight-bold px-9 py-4 my-3 mx-4"
            >
              Cancel
            </Button>
          </Link>
          <Button
            className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
            onClick={handleSave}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
};
